import { render, staticRenderFns } from "./Gang.vue?vue&type=template&id=52139e4a&"
import script from "./Gang.vue?vue&type=script&lang=js&"
export * from "./Gang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports